"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var SuggestionsFilter = function SuggestionsFilter(searchValue, suggestions) {
  var value = searchValue.toLowerCase();
  var filteredSuggestions = suggestions.filter(function (suggestion) {
    return !value || suggestion.name.toLowerCase().indexOf(value) > -1;
  });
  var sortedSuggestions = filteredSuggestions.sort(function (item) {
    return item.name.length;
  });
  var length = sortedSuggestions.length < 5 ? sortedSuggestions.length : 5;
  return sortedSuggestions.slice(0, length);
};

var _default = SuggestionsFilter;
exports["default"] = _default;
module.exports = exports.default;